<template>
  <div class="inform">
    <img src="@/assets/img/pic_banner.png" alt="" />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 注册入围审核进度查询
    </div>
    <RegisterForm class="inform_form_wrap"></RegisterForm>
    <div class="btn_1" @click="submit">提交申请</div>
  </div>
</template>

<script>
import RegisterForm from '@/components/common/RegisterForm'
export default {
  components: { RegisterForm },
  methods: {
    submit() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.inform {
  .btn_1 {
    font-weight: bold;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin: 25px 0 40px;
    width: 160px;
  }
}
.inform_form_wrap {
  margin: 0 15px;
}
</style>
